(function () {
  document.documentElement.classList.add("js");

  var openBtn = document.getElementById("menu-open");
  var closeBtn = document.getElementById("menu-close");
  var menu = document.getElementById("mobile-menu");
  function setMenu(on) {
    if (!menu) return;
    menu.classList.toggle("on", on);
    document.body.style.overflow = on ? "hidden" : "";
  }
  if (openBtn) openBtn.addEventListener("click", function () { setMenu(true); });
  if (closeBtn) closeBtn.addEventListener("click", function () { setMenu(false); });

  document.querySelectorAll(".js-qty-minus, .js-qty-plus").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var wrap = btn.closest(".qty");
      if (!wrap) return;
      var input = wrap.querySelector(".js-qty-input");
      if (!input) return;
      var n = parseInt(input.value || "1", 10);
      if (btn.classList.contains("js-qty-minus")) n = Math.max(1, n - 1);
      else n = n + 1;
      input.value = String(n);
    });
  });
})();
